/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUrlParameter } from "../functions/get-url-parameter.js";

const __vue_script__ = {
  data() {
    return {
      coupon: getUrlParameter('coupon') || '',
      loading: false,
      error: "",
      success: false
    }
  },
  mounted() {
    if (this.coupon) {
      this.submit();
    }
  },
  methods: {
    submit() {
      payload = {
        code: this.coupon,
        product_code: window.product.code,
      }
      if (window.offer) {
        payload.offer_code = window.offer.code;
      }
      this.loading = true;
      $.post(window.apiUrl + "/v1/payment/check/coupon", payload)
        .done((data) => {
          this.success = true;
          this.error = "";
          this.$emit('apply', {
            discount: data.discount,
            installments: data.installments,
            coupon: this.coupon
          });
        })
        .fail((data) => {
          this.error = data.responseJSON.message || 'Erro ao aplicar cupom!';
        })
        .always(() => {
          this.loading = false;
        });
    }
  },
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "discount-coupon" }, [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _c("div", { staticClass: "position-relative" }, [
          _c("i", { staticClass: "icon-ticket" }),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.coupon,
                expression: "coupon",
              },
            ],
            staticClass: "form-control",
            attrs: {
              type: "text",
              placeholder: "Cupom de desconto",
              disabled: _vm.loading || _vm.success,
            },
            domProps: { value: _vm.coupon },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.coupon = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.success ? _c("i", { staticClass: "icon-check" }) : _vm._e(),
          _vm._v(" "),
          _vm.loading ? _c("i", { staticClass: "icon-refresh-ccw" }) : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.error
          ? _c("small", { staticClass: "text-danger" }, [
              _vm._v(_vm._s(_vm.error)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.coupon && !_vm.success
          ? _c(
              "button",
              {
                staticClass: "btn btn-outline-primary btn-block",
                attrs: { type: "submit", disabled: _vm.loading },
              },
              [_vm._v("\n      Aplicar cupom\n    ")]
            )
          : _vm._e(),
      ]
    ),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-65356411_0", { source: ".discount-coupon form {\n  position: relative;\n}\n.discount-coupon form i {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 24px;\n}\n.discount-coupon form .icon-ticket {\n  color: #0034f0;\n  left: 12px;\n}\n.discount-coupon form .icon-check {\n  color: #7FCF69;\n  right: 12px;\n}\n.discount-coupon form .icon-refresh-ccw {\n  color: #0034f0;\n  right: 12px;\n}\n.discount-coupon form .icon-refresh-ccw::before {\n  animation: rotate 2s linear infinite;\n  display: inline-block;\n}\n.discount-coupon form input {\n  padding-left: 40px;\n  padding-right: 40px;\n  min-height: 48px;\n}\n.discount-coupon form button {\n  margin-top: 16px;\n  border: 1px solid #0034f0;\n}\n@keyframes rotate {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}\n\n/*# sourceMappingURL=discount-coupon.vue.map */", map: {"version":3,"sources":["frontend/components/discount-coupon.vue","discount-coupon.vue"],"names":[],"mappings":"AAqEA;EACA,kBAAA;ACpEA;ADsEA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;ACpEA;ADuEA;EACA,cAAA;EACA,UAAA;ACrEA;ADwEA;EACA,cAAA;EACA,WAAA;ACtEA;ADyEA;EACA,cAAA;EACA,WAAA;ACvEA;ADyEA;EACA,oCAAA;EACA,qBAAA;ACvEA;AD2EA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;ACzEA;AD4EA;EACA,gBAAA;EACA,yBAAA;AC1EA;AD+EA;AACA;IACA,uBAAA;AC5EE;AD8EF;IACA,yBAAA;AC5EE;AACF;;AAEA,8CAA8C","file":"discount-coupon.vue","sourcesContent":["<template>\n  <div class=\"discount-coupon\">\n    <form @submit.prevent=\"submit\">\n      <div class=\"position-relative\">\n        <i class=\"icon-ticket\"></i>\n        <input v-model=\"coupon\" class=\"form-control\" type=\"text\" placeholder=\"Cupom de desconto\" :disabled=\"loading || success\" />\n        <i v-if=\"success\" class=\"icon-check\"></i>\n        <i v-if=\"loading\" class=\"icon-refresh-ccw\"></i>\n      </div>\n      <small v-if=\"error\" class=\"text-danger\">{{ error }}</small>\n      <button v-if=\"coupon && !success\" class=\"btn btn-outline-primary btn-block\" type=\"submit\" :disabled=\"loading\">\n        Aplicar cupom\n      </button>\n    </form>\n  </div>\n</template>\n\n<script>\nimport { getUrlParameter } from \"../functions/get-url-parameter.js\";\n\nexport default {\n  data() {\n    return {\n      coupon: getUrlParameter('coupon') || '',\n      loading: false,\n      error: \"\",\n      success: false\n    }\n  },\n  mounted() {\n    if (this.coupon) {\n      this.submit();\n    }\n  },\n  methods: {\n    submit() {\n      payload = {\n        code: this.coupon,\n        product_code: window.product.code,\n      }\n      if (window.offer) {\n        payload.offer_code = window.offer.code;\n      }\n      this.loading = true;\n      $.post(window.apiUrl + \"/v1/payment/check/coupon\", payload)\n        .done((data) => {\n          this.success = true;\n          this.error = \"\";\n          this.$emit('apply', {\n            discount: data.discount,\n            installments: data.installments,\n            coupon: this.coupon\n          });\n        })\n        .fail((data) => {\n          this.error = data.responseJSON.message || 'Erro ao aplicar cupom!';\n        })\n        .always(() => {\n          this.loading = false;\n        });\n    }\n  },\n}\n</script>\n\n<style lang=\"scss\">\n@import \"../scss/variables.scss\";\n\n.discount-coupon {\n  form {\n    position: relative;\n\n    i {\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      font-size: 24px;\n    }\n    \n    .icon-ticket {\n      color: $primary;\n      left: 12px;\n    }\n    \n    .icon-check {\n      color: $success;\n      right: 12px;\n    }\n    \n    .icon-refresh-ccw {\n      color: $primary;\n      right: 12px;\n      \n      &::before {\n        animation: rotate 2s linear infinite;\n        display: inline-block;\n      }\n    }\n\n    input {\n      padding-left: 40px;\n      padding-right: 40px;\n      min-height: 48px;\n    }\n\n    button {\n      margin-top: 16px;\n      border: 1px solid $primary;\n    }\n  }\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n</style>",".discount-coupon form {\n  position: relative;\n}\n.discount-coupon form i {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 24px;\n}\n.discount-coupon form .icon-ticket {\n  color: #0034f0;\n  left: 12px;\n}\n.discount-coupon form .icon-check {\n  color: #7FCF69;\n  right: 12px;\n}\n.discount-coupon form .icon-refresh-ccw {\n  color: #0034f0;\n  right: 12px;\n}\n.discount-coupon form .icon-refresh-ccw::before {\n  animation: rotate 2s linear infinite;\n  display: inline-block;\n}\n.discount-coupon form input {\n  padding-left: 40px;\n  padding-right: 40px;\n  min-height: 48px;\n}\n.discount-coupon form button {\n  margin-top: 16px;\n  border: 1px solid #0034f0;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/*# sourceMappingURL=discount-coupon.vue.map */"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frontend/components/discount-coupon.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__